import classNames from "classnames";
import {forwardRef} from "react";

import {IconProps} from "@/components/icon/Icon.types.ts";

import styles from "./Icon.module.scss";

// This is a component that renders an icon. It is extremely flexible and can be used in many different ways.
// Please use this component for all icons in the application.
// Custom sizes should be defined in the design system. If you think a custom size is needed, please create a new size in the design system and use it here.
export const Icon = forwardRef<HTMLDivElement, IconProps>(
  ({icon, className, shape, size = "normal", display = "flex", removeDivDimensions = false, ...rest}, ref) => {
    const IconComponent = icon;

    // to inline the icon there are two approaches. wrapping the icon in a span, inline block with vertical align px exact based on what is aligning against
    // the other is to display inline block and set with vertical align px exact based on what is aligning against directly on the icon
    // for inline, given this is probably specifically for text it would be possible to determine all the exact px values to center on the different text sizes.

    //when using inline display, to line things up properly you will need to set the vertical align px value. Default is -1px

    // Using FI icons, the default sizes for some are much smaller than expected,
    // e.g. FiPlus at 1rem is 9.3 line length when figma has it at 11.3 line length closer to the 20px size
    return (
      // should this be a span?
      <div
        ref={ref}
        className={classNames(
          styles.icon,
          styles[size],
          shape && styles[shape],
          {[styles.removeDivDimensions]: removeDivDimensions}, // should only be used for aligning with small text
          styles[display],
          className
        )}
        {...rest}
      >
        {/* in trust-291 remove all the react icon context it is no longer needed and is confusing */}
        <IconComponent className={styles[size]} style={{verticalAlign: "inherit"}} />
      </div>
    );
  }
);
